export default __webpack_public_path__ + "static/150-min-min-3f06a3880b0d2453d911f20498c591c9.jpg";